<mat-dialog-content>
  <rpe-registro-actividad-laboratorio [formInput]="laboratorio" (formStatusChanges)="formStatusChange($event)"
    (formValueChanges)="formValueChange($event)"></rpe-registro-actividad-laboratorio>
  <div class="action">
    <button (click)="onCancel()" mat-raised-button>
      Cerrar
    </button>
    <button (click)="onAdd()" mat-raised-button>
      Registrar
    </button>
  </div>
</mat-dialog-content>
